<template>
  <div class="container section">
    <div class="row heading">
      <div class="col">
        <h2>Lead Carrier Products</h2>
      </div>
    </div>

    <div class="container-fluid" v-for="v, i in leadCarrierProducts" :key="v.leadCarrierProduct_id" >

      <div v-show="!selected || selected.leadCarrierProduct_id != v.leadCarrierProduct_id">
        <div class="row table-head">
          <div class="col"><strong>{{showCarrierName(v)}}</strong>
          </div>

          <div class="col text-right">
            <button class="btn btn-sm btn-primary" @click.stop="setSelected(v);" ><i class="fa fa-pencil"></i></button>
            <dropdown-confirmation @confirm="deleteProduct(v)"></dropdown-confirmation>
          </div>
        </div>
        <div class="row lined">
          <div class="col-6 col-md-3"><label>MRC</label></div>
          <div class="col-6 col-md-3">{{v.mrc | formatDollar}}</div>
          <div class="col-6 col-md-3"><label>Spiff</label></div>
          <div class="col-6 col-md-3">{{v.spiff | formatDollar}}</div>
        </div>
        <div class="row lined">
          <div class="col-6 col-md-3"><label>Phone</label></div>
          <div class="col-6 col-md-3">{{v.telno || "-"}}</div>
          <div class="col-6 col-md-3"><label>Qty</label></div>
          <div class="col-6 col-md-3">{{v.qty || "-"}}</div>
        </div>
        <div class="row lined">
          <div class="col-12 col-sm-6 col-md-3"><label>Billing Start</label></div>
          <div class="col-12 col-sm-6 col-md-3">{{v.billing_startdate | formatDate}}</div>

          <div class="col-12 col-sm-6 col-md-3"><label>IP Address</label></div>
          <div class="col-12 col-sm-6 col-md-3">{{v.ip_address }}</div>
        </div>
        <div class="row">

          <div class="col-12 col-sm-6 col-md-3"><label>Address</label>

          </div>
          <div class="col-12 col-sm-9">
            <img v-show="v.location.location_id != null" class="minimap" @click.stop="setShowMap(v.location)" src="/static/images/mapicon.png"> &nbsp;
            {{v.location.formatted_address}}</div>
        </div>
      </div>

      <div v-show="(!v.leadCarrierProduct_id) || (selected.leadCarrierProduct_id != null &&  selected.leadCarrierProduct_id == v.leadCarrierProduct_id)">
        <div class="row">
          <div class="col-4 col-md-3">Product Name</div>
          <div class="col-4">
            <dropdown
                    v-show="!v.leadCarrierProduct_id || (selected.leadCarrierProduct_id != null &&  selected.leadCarrierProduct_id == v.leadCarrierProduct_id)"
                    :list="carrierProductNames"
                    :value="showCarrierName(selected)"
                    @input="setProductId"
            ></dropdown>
          </div>
          <div class="col text-right">
            <button class="btn btn-sm btn-success" @click.stop="updateProduct(i)"><i class="fa fa-check"></i></button>
            <button class="btn btn-sm btn-danger" @click.stop="cancel"><i class="fa fa-close"></i></button>
          </div>
          <div class="w-100"></div>
          <div class="col-4 col-md-3">MRC</div>
          <div class="col-8 col-md-3">
            <input type="text" class="form-control" v-model="selected.mrc" @keyup.enter="updateProduct(i)" />
          </div>
          <div class="col-4 col-md-3">Spiff</div>
          <div class="col-8 col-md-3">
            <input type="text" class="form-control" v-model="selected.spiff" @keyup.enter="updateProduct(i)" />
          </div>
          <div class="col-4 col-md-3">Phone</div>
          <div class="col-8 col-md-3">
            <input type="text" class="form-control" v-model="selected.telno" @keyup.enter="updateProduct(i)" />
          </div>
          <div class="col-4 col-md-3">Qty</div>
          <div class="col-8 col-md-3">
            <input type="text" class="form-control" v-model="selected.qty" @keyup.enter="updateProduct(i)" />
          </div>
          <div class="col-4 col-sm-4 col-md-3">Billing Start</div>
          <div class="col-8 col-sm-8 col-md-3">
            <div class="input-group">
              <datepicker
                      input-class="form-control"
                      wrapper-class="datepicker-wrapper input-group"
                      :value="selected.billing_startdate | formatDate"
                      @selected="setStartDate"
                      format="MM/dd/yyyy"
              ></datepicker>
              <div class="input-group-addon clear">
                <i class="fa fa-calendar"></i>
              </div>
            </div>
          </div>

          <div class="col-4 col-md-3">IP Address</div>
          <div class="col-8 col-md-3">
            <input type="text" @keyup.enter="updateProduct(i)" class="form-control" v-model="selected.ip_address" />
          </div>



          <div class="w-100"></div>
          <div class="col-4 col-sm-4 col-md-3">Address</div>
          <div class="col-8 col-sm-8 col-md-9">
            <auto-complete
                    loose
                    placeholder="Enter Billing Address"
                    :list="addressNames"
                    :selection="getSelectedAddress"
                    @input="findAddresses"
                    @change="setAddress"
            ></auto-complete>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button class="btn btn-primary" @click="addNewProduct()"><i class="fa fa-plus"></i> &nbsp;Add Product</button>
      </div>
    </div>

    <modal v-if="showMap" size="lg" allow-click-away="false">
      <div slot="header">
        <h3 class="modal-title d-inline d-flex justify-content-start">Choose Providers</h3>
        <button type="button" class="btn btn-clear close-btn"  @click="showMap = false">
          <i class="fa fa-remove" />
        </button>
      </div>
      </h3>
      <mini-map size="lg" slot="body" :address="selectedLocation" :carriers="carriers" @close="showMap = false">
      </mini-map>
    </modal>


    <modal v-if="showAddProduct  || (loaded && leadCarrier_id && !leadCarrierProducts.length)" allow-click-away="false">
      <div slot="header">
        <h3 class="modal-title d-inline d-flex justify-content-start">Add Product</h3>
        <button @click="resetSelected(); showAddProduct = false" v-show="leadCarrierProducts.length" type="button" class="btn btn-clear close-btn" >
          <i class="fa fa-remove"  />
        </button>
      </div>
      </h3>

      <div slot="body">
        <div class="row" v-show="!leadCarrierProducts.length" style="margin-bottom: 10px;">
          <div class="col-12 bg-info text-white">
            Please enter a product to get started
          </div>
        </div>
        <div class="row">
          <div class="col-4">Product Name</div>
          <div class="col-8 col-sm-6">
            <dropdown
                    :list="carrierProductNames"
                    :value="showCarrierName(selected)"
                    @input="setProductId"
            ></dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-4">MRC</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.mrc" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Spiff</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.spiff" />
          </div>
        </div>
        <div class="row" v-show="selectedProduct.telephone">
          <div class="col-4">Phone</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.telno" />
          </div>
        </div>
        <div class="row" v-show="selectedProduct.ip_address">
          <div class="col-4">IP Address</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.ip_address" />
          </div>
        </div>
        <div class="row">
          <div class="col-4 ">Qty</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.qty" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Billing Start</div>
          <div class="col-8 col-sm-6">
            <div class="input-group">
              <datepicker
                      input-class="form-control"
                      wrapper-class="datepicker-wrapper input-group"
                      :value="selected.billing_startdate | formatDate"
                      @selected="setStartDate"
                      format="MM/dd/yyyy"
              ></datepicker>
              <div class="input-group-addon clear">
                <i class="fa fa-calendar"></i>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-4">Address</div>
          <div class="col-8">
            <auto-complete
                    loose
                    placeholder="Enter Service Address"
                    :list="addressNames"
                    :selection="getSelectedAddress"
                    @input="findAddresses"
                    @change="setAddress"
            ></auto-complete>
          </div>
        </div>
        <div class="modal-footer">
          <button v-show="leadCarrierProducts.length" class="btn btn-clear" @click.stop="resetSelected();showAddProduct = false">Cancel</button>
          <button class="btn btn-primary" @click.stop="saveNewProduct()"><i class="fa fa-check"></i> Save Product</button>
        </div>
      </div>
    </modal>

  </div>
</template>
<script type="text/babel">

  import Modal from '../assets/Modal.vue';
  import MiniMap from '../includes/MiniMap.vue';
  import Dropdown from '../assets/Dropdown.vue';
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  import AutoComplete  from '../assets/Autocomplete.vue';
  import Datepicker from 'vuejs-datepicker';
  export default {
    name: 'leadCarrierProducts',
    data: function () {
      return {
        loaded:false,
        map:{},
        params: {
          function: 'leadCarrierProducts',
          data: {
            leadCarrier_id: ''
          }
        },
        newProduct:{
          leadCarrierProduct_id: null,
          product_id: null,
          qty: 1,
          mrc: 0
        },
        leadCarrierProducts:[],
        showAddProduct: false,
        selected: {
          leadCarrierProduct_id: '',
          product_id: '',
          billing_startdate: '',
          mrc: '',
          qty: '',
          ip_address: '',
          telno: '',
          spiff: '',
          location: {
            location_id: '',
            formatted_address: ''
          }
        },
        showMap: false,
        address: '',
        addresses:[],
        selectedLocation:{

        }
      }
    },
    components: {
      Dropdown,
      DropdownConfirmation,
      Modal,
      MiniMap,
      Datepicker,
      AutoComplete
    },
    created(){
      this.map = new window.TCMap();
      this.fetchLeadCarrierProducts();
      this.resetSelected();
    },
    computed: {
      getSelectedAddress(){
        if(this.selected.location){
          return this.selected.location.formatted_address
        }
        return '';
      },
      addressNames(){
        return this.addresses.map(function(a){
          return a.formatted_address;
        })
      },
      carrierProductNames(){
        return this.carrierProducts.map(function (cp) {
          return cp.name;
        })
      },
      selectedProduct(){
        var _this = this;

        if(! _this.selected.product_id) return {};

        return this.carrierProducts.filter(function (cp) {
                  return cp.product_id == _this.selected.product_id;
                })[0] || {}
      }
    },

    filters:{
      formatDate(val){
        if(!val) return "-";
        return moment(val, 'YYYY-MM-DD').format('MM/DD/YYYY');
      },
      formatDollar(val){
        if(!val) return "-";
        return "$" + val;
      }
    },
    methods: {
      setStartDate(value){
        this.selected.billing_startdate = moment(value, 'MM/DD/YYYY').format('YYYY-MM-DD');
      },
      findAddresses(address){

        this.selected.location.formatted_address = address;
        this.searchGoogle(address);

      },
      searchGoogle: _.debounce(function(address) {
        var _this = this;
        this.map.search(address, function (err, data) {
          if (err) {
            console.error(err);
          } else {
            _this.addresses = data;
          }
        })

      }, 500),

      setAddress(address){
        if(!address) return;

        this.address = this.addresses.filter(function(a){

          return a.formatted_address == address;
        }).map(function(a){


          var data = {
            formatted_address: a.formatted_address,
            geolat: a.geometry.location.lat(),
            geolong: a.geometry.location.lng(),
            address: a.address_components[0].short_name + ' ' + a.address_components[1].short_name
          };
          if(a.address_components[2]) data.neighborhood =  a.address_components[2].short_name;
          if(a.address_components[3]) data.city =  a.address_components[2].short_name;
          if(a.address_components[5]) data.state =  a.address_components[5].short_name;
          if(a.address_components[6]) data.country =  a.address_components[6].short_name;
          if(a.address_components[7]) data.zip =  a.address_components[7].short_name;
          return data;
        })[0];

        if(this.address){
          this.selected.location = this.address;
        } else {
          this.selected.location = {
            formatted_address: ''
          };
        }
      },

      setShowMap(location){

        this.selectedLocation = location;
        this.showMap = true;
      },

      setSelected(v){
        if(this.selected.leadCarrierProduct_id != v.leadCarrierProduct_id){
          this.selected = JSON.parse(JSON.stringify(v));
        }
      },
      edit(product){
        this.selected = product;
      },
      cancel(){
        this.resetSelected();
      },
      resetSelected(){

        this.selected = {
          leadCarrierProduct_id: '',
          product_id: '',
          billing_startdate: moment().add(45, 'days').format('YYYY-MM-DD'),
          mrc: '',
          qty: '',
          telno: '',
          spiff: '',
          location: this.details.location
        }
      },
      setProductId(name){

        this.selected.product_id = this.carrierProducts.filter(function (cp) {

          return cp.name == name;
        }).map(function (p) {
          return p.product_id;
        })[0];

      },
      saveNewProduct(){
        this.selected.leadCarrier_id = this.leadCarrier_id;
        this.$send(this, 'leadCarrierProductUpdate', this.selected).then(r => {
          this.showAddProduct = false;
          this.resetSelected();
          this.fetchLeadCarrierProducts();
        });

      },
      addNewProduct(){
        this.resetSelected();

        this.showAddProduct = true;
      },
      updateProduct(i){
        var data = JSON.parse(JSON.stringify(this.selected));
        data.location = this.selected.location.formatted_address;
        data.leadCarrier_id = this.leadCarrier_id;
        this.$send(this, 'leadCarrierProductUpdate', data).then(r => {
          this.resetSelected();
          this.fetchLeadCarrierProducts();
        });

      },

      fetchLeadCarrierProducts(){
        var _this = this;

        this.$send(this, 'leadCarrierProducts', {
          leadCarrier_id: this.leadCarrier_id
        }).then(r => {
          this.leadCarrierProducts = r.leadCarrierProducts;
          this.$nextTick(function(){
            this.loaded = true;
          })
        });

      },

      deleteProduct(v){
        var _this = this;

        this.$send(this, 'leadCarrierProductDelete', {
          leadCarrierProduct_id: v.leadCarrierProduct_id
        }).then(r => {
          this.fetchLeadCarrierProducts();
        });

      },
      showCarrierName(p){
        if (!this.carrierProducts) return null;
        return this.carrierProducts.filter(function (cp) {
          return cp.product_id == p.product_id;
        }).map(function (p) {
          return p.name;
        })[0];
      }

    },
    watch:{
      leadCarrier_id(){
        this.fetchLeadCarrierProducts();
      }
    },

    props: {
      details: {
        type: Object
      },
      carriers:{},
      leadCarrier_id:{

      },
      carrierProducts: {}

    }

  }

</script>



// WEBPACK FOOTER //
// LeadCarrierProducts.vue?db365b72